module.exports = __webpack_public_path__ + "assets/images/announcement-multiple-dashboards.png";